export default {"src":"/_next/static/media/mobile-menu.5f3e031f.svg","height":14,"width":18,"blurWidth":0,"blurHeight":0};